import axios from 'axios';
import config from '../../config';

import tokenApi from './tokenApi';

const userInstance = axios.create({
	baseURL: config.api,
    headers: {
		'Content-Type': 'application/json'
	}
});

class UserApi {
	static UserConfirmPassword(payload) {
		return userInstance.post('/auth/login', payload)
		.then(function (response) {
			return response.data;
		})
		.catch(function (error) {
			throw(error);
		});
	}

	static UserLogin(payload) {
		return userInstance.post('/auth/login', payload)
		.then(function (response) {
			return response.data;
		})
		.catch(function (error) {
			throw(error);
		});
	}

	static async UserInsert(payload) {
		userInstance.defaults.headers.common['Authorization'] = await tokenApi.GetTokenAsync();
		try {
			const response = await userInstance.post(`/users`, payload);
			return response.data;
		} catch (error) {
			throw error;
		}
	}

	static async UserUpdate(payload, id) {
		userInstance.defaults.headers.common['Authorization'] = await tokenApi.GetTokenAsync();
		try {
			const response = await userInstance.patch(`/users/${id}`, payload);
			return response.data;
		} catch (error) {
			throw error;
		}
	}

	static async UserList(data) {
		userInstance.defaults.headers.common['Authorization'] = await tokenApi.GetTokenAsync();
		try {
			const response = await userInstance.get('/users');
			return response.data;
		} catch (error) {
			throw error;
		}
	}

	static async UserDelete(userId) {
		userInstance.defaults.headers.common['Authorization'] = await tokenApi.GetTokenAsync();
		try {
			const response = await userInstance.delete(`/users/${userId}`);
			return response.data;
		} catch (error) {
			throw error;
		}
	}

}

export default UserApi;
